import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { cva } from 'class-variance-authority'
import { CheckIcon } from 'lucide-react'
import * as React from 'react'

import { cn } from '@/lib/utils'

import { Label } from './label'

let idCounter = 0
const checkboxVariants = cva(
  'peer border-text-secondary dark:bg-input/30 data-[state=checked]:text-primary-foreground dark:data-[state=checked]:bg-primary data-[state=checked]:border-icon-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive flex shrink-0 items-center justify-center border p-[2px] transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      variant: {
        circular: 'rounded-full',
        square: 'rounded-sm transition-colors data-[state=checked]:bg-icon-primary',
      },
      size: {
        default: 'size-4',
        sm: 'size-3',
        lg: 'size-5',
      },
    },
    defaultVariants: {
      variant: 'circular',
      size: 'default',
    },
  }
)
interface CheckboxProps extends React.ComponentProps<typeof CheckboxPrimitive.Root> {
  label?: string
  labelClassName?: string
  variant?: 'circular' | 'square'
  size?: 'default' | 'sm' | 'lg'
}

function Checkbox({ className, label, labelClassName, id, variant = 'circular', size, ...props }: CheckboxProps) {
  const checkboxIdRef = React.useRef<string | null>(null)

  if (!checkboxIdRef.current) {
    checkboxIdRef.current = `checkbox-${++idCounter}`
  }

  const finalId = id || checkboxIdRef.current

  const checkbox = (
    <CheckboxPrimitive.Root id={finalId} data-slot='checkbox' className={cn(checkboxVariants({ variant, size, className }))} {...props}>
      {variant === 'circular' ? (
        <CheckboxPrimitive.Indicator
          data-slot='checkbox-indicator'
          className={cn('bg-icon-primary flex size-full items-center justify-center rounded-full')}
        ></CheckboxPrimitive.Indicator>
      ) : (
        <CheckboxPrimitive.Indicator data-slot='checkbox-indicator' className='flex size-full items-center justify-center'>
          <CheckIcon strokeWidth={4} className='size-full' />
        </CheckboxPrimitive.Indicator>
      )}
    </CheckboxPrimitive.Root>
  )

  if (label) {
    return (
      <div className='flex items-center gap-2'>
        {checkbox}
        <Label className={cn('mb-0', labelClassName)} htmlFor={finalId}>
          {label}
        </Label>
      </div>
    )
  }

  return checkbox
}

export { Checkbox }
